import React from 'react';
import { NavLink } from 'react-router-dom';

import OnboardingRoute from './onboarding.route';

const OnboardingMenu = () => {
  return (
    <div className="navbar-collapse">
      <div className="d-flex flex-column navbar-dark">
        <ul className="navbar-nav ">
          {OnboardingRoute?.map((menu, index) => {
            return (
              <li key={index} className="nav-item">
                <NavLink
                  onClick={(e) => e.preventDefault(false)}
                  to={menu.path}
                  className="nav-link-tabs px-md-4 py-md-3 px-2 disabled"
                  activeClassName="active"
                  isActive={(match, location) => {
                    const splitLocation = location.pathname.split('/');

                    if (splitLocation[1] === menu.isActive) {
                      return true;
                    }
                  }}
                >
                  <div className="d-flex flex-column flex-md-row align-items-md-center p-2 p-md-0">
                    <div className="pe-3 pb-2 pb-md-0">
                      <div className="d-flex justify-content-center align-items-center rounded-circle num-circle">
                        {index + 1}
                      </div>
                    </div>
                    <div className="row">
                      <span
                        className="nav-link-title fw-semibold"
                        style={{ fontSize: 14 }}
                      >
                        {menu?.title}
                      </span>
                      {menu?.subtitle && (
                        <span
                          className="page-subtitle fw-normal"
                          style={{ fontSize: 12, color: '#BEBEBF' }}
                        >
                          {menu?.subtitle}
                        </span>
                      )}
                    </div>
                  </div>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default OnboardingMenu;
